import {useEffect, type ReactNode} from 'react'

interface ConfirmModalProps {
  open: boolean
  title: string
  body?: ReactNode
  confirmLabel: string
  cancelLabel: string
  variant?: 'primary' | 'danger'
  onConfirm: () => void
  onClose: () => void
  badge?: ReactNode
}

const ConfirmModal = ({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  variant = 'primary',
  onConfirm,
  onClose,
  badge,
}: ConfirmModalProps) => {
  // Close on Escape
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  const confirmClass = variant === 'danger' ? 'btn-primary btn-danger' : 'btn-primary'

  return (
    <div className="mp-modal-backdrop" onClick={onClose}>
      <div className="mp-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        {badge}
        <h3>{title}</h3>
        {body && <div className="mp-modal-body">{body}</div>}
        <div className="mp-modal-actions">
          <button type="button" className="btn-ghost" onClick={onClose}>
            {cancelLabel}
          </button>
          <button type="button" className={confirmClass} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
